import { render, staticRenderFns } from "./FrontLayout.vue?vue&type=template&id=302712c8"
import script from "./FrontLayout.vue?vue&type=script&lang=js"
export * from "./FrontLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports